export enum HCLModelTagTypeKey {
  MISSION = 'MI',
  PROJECT = 'PR',
  SUBSYSTEM = 'SU',
  COMPONENT = 'CO',
  TRANSFER_GATE = 'TR'
}

export enum HCLModelName {
  MISSION = 'Mission',
  PROJECT = 'Project',
  SUBSYSTEM = 'Subsystem',
  COMPONENT = 'Component',
  TRANSFER_GATE = 'Transfer Gate'
}

export interface HCLModelType {
  tag: HCLModelTagTypeKey,
  name: HCLModelName,
}

export interface HCLModelTypeMission extends HCLModelType {
  tag: HCLModelTagTypeKey.MISSION,
  name: HCLModelName.MISSION
}

export interface HCLModelTypeProject extends HCLModelType {
  tag: HCLModelTagTypeKey.PROJECT,
  name: HCLModelName.PROJECT
}

export interface HCLModelTypeSubsystem extends HCLModelType {
  tag: HCLModelTagTypeKey.SUBSYSTEM,
  name: HCLModelName.SUBSYSTEM
}

export interface HCLModelTypeComponent extends HCLModelType {
  tag: HCLModelTagTypeKey.COMPONENT,
  name: HCLModelName.COMPONENT
}

const HCLModelTypes = {
  [HCLModelTagTypeKey.MISSION] : {
    tag: HCLModelTagTypeKey.MISSION,
    name: HCLModelName.MISSION,
  },
  [HCLModelTagTypeKey.PROJECT] : {
    tag: HCLModelTagTypeKey.PROJECT,
    name: HCLModelName.PROJECT,
  },
  [HCLModelTagTypeKey.SUBSYSTEM] : {
    tag: HCLModelTagTypeKey.SUBSYSTEM,
    name: HCLModelName.SUBSYSTEM,
  },
  [HCLModelTagTypeKey.COMPONENT] : {
    tag: HCLModelTagTypeKey.COMPONENT,
    name: HCLModelName.COMPONENT,
  },
  [HCLModelTagTypeKey.TRANSFER_GATE] : {
    tag: HCLModelTagTypeKey.TRANSFER_GATE,
    name: HCLModelName.TRANSFER_GATE,
  },
}

export default HCLModelTypes;

